module.exports = __webpack_public_path__ + "static/media/tb-mlanders.a3e2ab8a.jpeg";